import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import React, { FC } from "react";

interface IProps {
    opened:boolean,
    setOpened:any,
    title:string,
    children:any
};

const AE2Modal:FC<IProps> = ({opened,setOpened,title,children}) => {
    return <IonModal className="upload-software-modal modal-background" isOpen={opened} onDidDismiss={()=>setOpened(false)}>
    <IonHeader>
        <IonToolbar>
          <IonTitle style={{color:'white'}}>{title}</IonTitle>
          <IonButtons slot="end">
            <IonButton style={{color:'white'}} onClick={() => setOpened(false)}>Close</IonButton>
          </IonButtons>
        </IonToolbar>
    </IonHeader>
    <IonContent class="ion-padding">
        {children}
    </IonContent>
    </IonModal>
};

export default AE2Modal;